var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoSales = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "32749201-5473-4EF4-8F10-58DE2E9B7E54") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wiki",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "12-wiki-Details",
    transform: "translate(-877.000000, -457.000000)",
    fill: "#191919",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main-topic",
    transform: "translate(100.000000, 126.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Marketing",
    transform: "translate(760.000000, 310.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_sales",
    transform: "translate(17.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.5617,8.2188 L11.4147,17.0718 L17.0717,11.4138 L8.2187,2.5618 L3.1267,3.1278 L2.5617,8.2188 Z M11.4147,19.8998 L0.4677,8.9528 L1.3167,1.3158 L8.9537,0.4678 L19.8997,11.4138 L11.4147,19.8998 Z",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.049,10.4565 C10.038,10.2685 10.001,10.0705 9.935,9.8645 C9.868,9.6575 9.791,9.4445 9.703,9.2265 C9.614,9.0065 9.572,8.8275 9.574,8.6855 C9.576,8.5445 9.639,8.4125 9.761,8.2895 C9.882,8.1695 10.007,8.1045 10.135,8.0965 C10.265,8.0885 10.383,8.1395 10.492,8.2485 C10.614,8.3705 10.662,8.5115 10.636,8.6695 C10.61,8.8285 10.51,8.9935 10.339,9.1645 L11.177,10.0025 C11.49,9.6885 11.663,9.3435 11.695,8.9665 C11.719,8.6685 11.627,8.3835 11.471,8.1035 L12.057,7.5185 L11.888,7.3485 L11.493,6.9545 L11.35,6.8105 L10.793,7.3685 C10.504,7.1705 10.208,7.0455 9.901,7.0395 C9.532,7.0325 9.207,7.1685 8.929,7.4475 C8.761,7.6145 8.646,7.7825 8.581,7.9535 C8.517,8.1235 8.49,8.3035 8.499,8.4905 C8.51,8.6795 8.549,8.8755 8.618,9.0805 C8.688,9.2855 8.771,9.5025 8.866,9.7305 C8.963,9.9585 9.006,10.1425 8.995,10.2805 C8.986,10.4185 8.915,10.5545 8.784,10.6845 C8.667,10.8025 8.543,10.8615 8.412,10.8645 C8.28,10.8675 8.158,10.8115 8.046,10.6995 C7.893,10.5455 7.823,10.3785 7.838,10.1965 C7.853,10.0145 7.954,9.8295 8.143,9.6405 L7.308,8.8055 C6.966,9.1475 6.786,9.5195 6.77,9.9215 C6.756,10.2565 6.888,10.5905 7.111,10.9235 L6.57,11.4645 L6.728,11.6215 L7.121,12.0155 L7.278,12.1715 L7.814,11.6355 C8.091,11.8195 8.373,11.9365 8.664,11.9375 C9.023,11.9385 9.342,11.7975 9.624,11.5145 C9.791,11.3475 9.906,11.1775 9.969,11.0015 C10.032,10.8265 10.059,10.6455 10.049,10.4565",
    id: "Fill-4"
  })))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoSales);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_sales.edeefeea6621fcc2fd9c0c9d0e5a094a.svg";